const source = {
	User: 1,
	Instagram: 2,
	Scrapper: 3
};

module.exports = { source };
